import type { Strapi5RequestParams } from '@nuxtjs/strapi';
import { textContentPopulations } from '~/populations/base';

const listPopulations: Readonly<Strapi5RequestParams> = {
  populate: {
    items: textContentPopulations,
  },
};

export const contentPopulations: Readonly<Strapi5RequestParams> = {
  populate: {
    text: true,
    lists: listPopulations,
  },
};
